import React, { useEffect, useRef, useState } from 'react';
import { STATS } from '../data/mock';

const Counter = ({ end, duration = 1800 }) => {
  const [val, setVal] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting && !started.current) {
          started.current = true;
          const start = performance.now();
          const step = (now) => {
            const p = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - p, 3);
            setVal(Math.floor(eased * end));
            if (p < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        }
      });
    }, { threshold: 0.5 });
    obs.observe(node);
    return () => obs.disconnect();
  }, [end, duration]);

  return <span ref={ref}>{val.toLocaleString()}</span>;
};

const StatsSection = () => (
  <section className="bg-[#2BBECF] py-16 -mt-10 relative z-10">
    <div className="max-w-[1200px] mx-auto px-6 grid grid-cols-2 lg:grid-cols-4 gap-6">
      {STATS.map((s, i) => (
        <div key={i} className="bg-white rounded-sm p-8 text-center shadow-sm card-lift">
          <div className="heading-display text-4xl md:text-5xl font-bold text-slate-900">
            <Counter end={s.value} />
          </div>
          <div className="mt-2 text-slate-500 text-sm md:text-base">{s.label}</div>
        </div>
      ))}
    </div>
  </section>
);

export default StatsSection;
